import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import update from "immutability-helper";
import { get, includes, map, forEach, filter, isEmpty } from "lodash";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
// import Radio from "@material-ui/core/Radio";
// import RadioGroup from "@material-ui/core/RadioGroup";
// import FormControlLabel from "@material-ui/core/FormControlLabel";

import CloseIcon from "../Common/CloseIcon";
import CustomButton from "../Common/CustomButton";
import FormSection from "../Common/FormSection";

import { getLov } from "../../utils/lov";
import { dbFormat } from "../../utils/date";

import images from "../../assets/img/images";

const styles = {
  dialog: {
    minWidth: "350px",
  },
  radioGroup: {
    flexDirection: "row",
  },
  formControlRoot: {
    marginRight: "24px",
  },
  plusIcon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
};

const AddTemperature = (props) => {
  const { classes, profile, language, onSubmit } = props;

  const [openForm, setOpenForm] = React.useState(props.open || false);
  const [formValues, setFormValues] = React.useState(props.formValues || {});
  const [lov, setLov] = React.useState();

  React.useEffect(() => {
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchLov = async () => {
    try {
      let tempUnit = await getLov(88);
      setLov({
        188: await getLov(188),
        88: tempUnit,
      });
      if (isEmpty(formValues)) {
        setFormValues(
          update(formValues, {
            88: {
              $set: get(
                filter(tempUnit, (item) => item.default),
                [0, "id"]
              ),
            },
          })
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  const onClose = () => {
    if (props.onClose) props.onClose();
    setOpenForm(false);
  };

  const handleChange = (id, index, value) => {
    if (includes([88], id)) value = parseInt(value);
    setFormValues(
      update(formValues, {
        [id]: { $set: value },
      })
    );
  };

  const submit = () => {
    let submitDate = dbFormat(Date.now());

    // Temperature event group
    let temperatureEventGroup = {
      type_id: 13,
      profile_id: get(profile, ["id"]),
      active: true,
      description: get(formValues, ["note"]) || "",
      start: submitDate,
      end: submitDate,
    };

    // Measured temperature event (82)
    let measuredTemperatureEvent = {
      type_id: 82,
      profile_id: get(profile, ["id"]),
      log_level: 1,
      attributes: [
        {
          id: 187,
          value: parseFloat(get(formValues, [187])),
        },
        {
          id: 88,
          //value: get(formValues, [88]),
          value: 20,
        },
        {
          id: 188,
          value: get(formValues, [188]),
        },
      ],
    };

    onSubmit(temperatureEventGroup, measuredTemperatureEvent);
    onClose();
  };

  const isValidForm = () => {
    let isValid = true;
    forEach([/*188,*/ 187, 88], (id) => {
      if (!get(formValues, [id])) {
        isValid = false;
      }
    });
    if (isNaN(parseFloat(get(formValues, [187])))) {
      isValid = false;
    }
    return isValid;
  };

  return (
    <>
      <Box className={classes.plusIcon} onClick={() => setOpenForm(true)}>
        <img src={images.plusIconColored} alt="plus" />
      </Box>
      <Dialog
        open={openForm}
        classes={{
          paperScrollPaper: classes.dialog,
        }}
      >
        <Grid
          container
          wrap="nowrap"
          direction="column"
          alignItems="stretch"
          style={{ paddingTop: "12px" }}
        >
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className="dialogTitle">
                {I18n.get("site_newTemperature")}
              </Grid>
              <Grid item xs={2} className={classes.closeBtn}>
                <CloseIcon closeFunction={onClose} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ padding: "24px" }}>
            <Grid container direction="column">
              <FormSection
                formValue={[get(formValues, [188]) || ""]}
                setFormValue={handleChange}
                attribute={{ id: 188 }}
                id={188}
                type="select"
                options={{
                  options: map(get(lov, [188]), (item) => ({
                    id: item.id,
                    name: get(item, [`name_${language}`]),
                  })),
                }}
              />
              <Grid item style={{ marginBottom: "10px" }}>
                <Grid container>
                  <Grid item style={{ width: "60px" }}>
                    <FormSection
                      formValue={[get(formValues, [187]) || ""]}
                      setFormValue={handleChange}
                      title2={I18n.get("site_temperatures")}
                      id={187}
                      type="input"
                      options={{
                        required: true,
                        redBorder: !get(formValues, [187]),
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    className="text-54"
                    style={{
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center",
                      height: "36px",
                      marginTop: "21px",
                    }}
                  >
                    °C
                    {/* <RadioGroup
                      name="tempType"
                      value={get(formValues, [88]) || ""}
                      onChange={(e) => handleChange(88, null, e.target.value)}
                      classes={{ root: classes.radioGroup }}
                    >
                      {map(get(lov, [88]), (item) => (
                        <FormControlLabel
                          key={item.id}
                          value={item.id}
                          control={<Radio color="primary" />}
                          label={item.id === 19 ? "°F" : "°C"}
                          classes={{
                            root: classes.formControlRoot,
                          }}
                        />
                      ))}
                    </RadioGroup> */}
                  </Grid>
                </Grid>
              </Grid>
              <FormSection
                formValue={[get(formValues, ["note"]) || ""]}
                setFormValue={handleChange}
                title={"comments"}
                id={"note"}
                type="input"
                options={{
                  multiline: true,
                  rows: 5,
                }}
              />
              <Grid item>
                <Grid container justify="center">
                  <Grid item>
                    <CustomButton color="primary" onClick={onClose}>
                      {I18n.get("site_cancel")}
                    </CustomButton>
                  </Grid>
                  <Grid item style={{ marginLeft: "10px" }}>
                    <CustomButton
                      variant="contained"
                      color="primary"
                      disabled={!isValidForm()}
                      onClick={submit}
                    >
                      {I18n.get("site_confirm")}
                    </CustomButton>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(AddTemperature);
